import transaction from '@apis/transaction'
import { outlinewallet } from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Status from '@components/status'
import Table from '@components/table'
import Title from '@components/title'
import { useModal } from '@context/ModalContext'
import { RootState } from '@store/index'
import dayjs from 'dayjs'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import DateRangeFilter from '@components/table/DateRangeFilter'
import StatusFilter from '@components/table/StatusFilter'
import styled from '@emotion/styled'

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    width: 100%;
  }
`

const Withdraw = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [status, setStatus] = useState('')

  const { showModal } = useModal()
  const {
    items: transactions = [],
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.transactions)
  console.log(transactions, 'fdf')
  const [page, setPage] = useState(1)
  const fetchTransactions = async (search = '') => {
    try {
      await transaction.list({
        state: 'transactions',
        params: {
          page,
          limit: 30,
          type: 'Withdraw',
          ...(search && { search }),
          ...(fromDate && { startDate: fromDate }),
          ...(toDate && { endDate: toDate }),
          ...(status && { status }),
        },
      })
    } catch (error) {
      console.error('Error fetching transactions:', error)
    }
  }
  const columns = [
    {
      title: 'Created By',
      key: 'created_byff',
      render: (item) => (
        <div>
          <>{item?.created_by?.name}</>
        </div>
      ),
    },
    {
      title: 'Phone No.',
      key: 'phone_no',
      render: (item) => item?.created_by?.phoneNo || 'N/A',
    },
    {
      title: 'Total Won Points',
      key: 'total_won_points',
      render: (item) => <p>{item?.created_by?.points}</p>,
    },
    {
      title: 'Withdrawn Amount',
      key: 'withdrawn_amount',
    },
    {
      title: 'method',
      key: 'method',
      render: (item) => <>{item.created_by?.infos?.method ?? '-'}</>,
    },
    {
      title: 'number',
      key: 'number',
      render: (item) => <>{item.created_by?.infos?.paymentNumber ?? '-'}</>,
    },
    {
      title: 'name',
      key: 'name',
      render: (item) => <>{item.created_by?.infos?.paymentName ?? '-'}</>,
    },
    {
      title: 'User QR',
      key: 'user_qr',
      render: (item) => (
        <img
          src={`https://admin.tournaop.com/${item?.created_by?.infos?.paymentQr}`}
          alt="QR"
          width={30}
          height={30}
          onClick={() => {
            showModal(
              <ShowImage
                src={`https://admin.tournaop.com/${item?.created_by?.infos?.paymentQr}`}
              />,
            )
          }}
        />
      ),
    },
    {
      title: 'Created Date',
      key: 'created_date',
      render: (item) => (
        <Column stylecolumn="row-gap:2px">
          <p>{item.created_date}</p>
          <p style={{ color: 'gray', fontSize: '12px' }}>{item.created_time}</p>
        </Column>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Status
          item={item}
          statuses={['Pending', 'Delivered', 'Cancelled']}
          onStatusChange={async (status) => {
            await transaction.update({ id: item.id, data: { status } })
          }}
        />
      ),
    },
  ]

  const data = Array.isArray(transactions)
    ? transactions.map((t) => ({
        id: t.id,
        created_by: t.user,
        withdrawn_amount: t.amount,
        created_date: t.createdAt ? t.createdAt.split('T')[0] : 'N/A',
        created_time: t.createdAt
          ? (() => {
              const [hour, min, sec] = t.createdAt
                .split('T')[1]
                .split('.')[0]
                .split(':')
              const h = Number(hour)
              const ampm = h >= 12 ? 'PM' : 'AM'
              const hour12 = h % 12 === 0 ? 12 : h % 12
              return `${hour12}:${min}:${sec} ${ampm}`
            })()
          : 'N/A',
        status: t.status,
      }))
    : []
  useEffect(() => {
    setPage(1)
  }, [searchTerm, fromDate, toDate, status])
  useEffect(() => {
    fetchTransactions(searchTerm)
  }, [searchTerm, page, fromDate, toDate, status])
  return (
    <Fragment>
      <Column>
        {/* <Grid>
          {Array.from({ length: 4 }).map((_, i) => (
            <Analytic key={i} />
          ))}
        </Grid> */}
        <Title textone="Payment >" texttwo="Withdraw" />
        <Table
          onSearchChange={(val) => {
            setSearchTerm(val)
          }}
          loading={loading}
          searchKeys={['name', 'number', 'amount']}
          itemsPerPage={30}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          onPageChange={setPage}
          text="Pending Withdrawn List"
          icon={outlinewallet}
          data={data}
          columns={columns}
          rightSearchElement={
            <HeaderActions>
              <DateRangeFilter
                fromDate={fromDate}
                toDate={toDate}
                onFromDateChange={setFromDate}
                onToDateChange={setToDate}
              />
              <StatusFilter value={status} onChange={setStatus} />
            </HeaderActions>
          }
        />
      </Column>
    </Fragment>
  )
}

export default Withdraw

const ShowImage = ({ src }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={src}
        alt=""
        width={550}
        height={550}
        style={{ objectFit: 'contain' }}
      />
    </div>
  )
}
